/*
  persistence.ts
    Util functions to standardize saving of data into localstorage for persistence
*/

// MSRP

// name of the variable to use as the parent for this storage in localStorage
const PERSISTENCE_KEY = 'persistence';

const saveStoredItem = (key: string, value: any) => {
  // get current store
  let current: any = null;
  try {
    current = JSON.parse(localStorage.getItem(PERSISTENCE_KEY));
    if (current == null) {
      throw new Error();
    }
  } catch {
    current = {};
  }
  // Modify
  current[key] = value;
  // Save
  localStorage.setItem(PERSISTENCE_KEY, JSON.stringify(current));
};

const retrieveStoredItem = (key: string): any => {
  // get current store
  let current: any = null;
  try {
    current = JSON.parse(localStorage.getItem(PERSISTENCE_KEY));
    if (current == null) {
      throw new Error();
    }
  } catch {
    return undefined;
  }
  return current[key];
};

export const saveMSRP = (msrp: boolean) => {
  saveStoredItem('msrp', msrp);
};

export const retrieveMSRP = (): boolean => {
  return retrieveStoredItem('msrp');
};

export const saveSearchText = (text: string) => {
  saveStoredItem('searchText', text.trim());
};

export const retrieveSearchText = (): string => {
  return retrieveStoredItem('searchText');
};
